import 'angular';

import '../polyfills';

import './admin-dashboard/admin-dashboard.module.ajs';
import "./ams-rewards/ams-rewards.module.ajs";
import './api/api.module';
import './assembly-payments/assembly-payments.module.ajs';
import './attachments/attachments.module.ajs';
import './azure-sso/azure-sso.module.ajs';
import './biller/biller.module.ajs';
import './branches/branches.module';
import './business-intelligence/business-intelligence.module.ajs';
import './carfax/carfax.module.ajs.ts';
import './chargify/chargify.module.ajs';
import './core/core.module.ajs';
import './companies/companies.module.ajs';
import './company-lists/company-lists.module.ajs';
import './customer-payments/customer-payments.module.ajs';
import './customer-portal/customer-portal.module.ajs';
import './customers/customers.module.ajs';
import './dealers/dealers.module.ajs';
import './dvla-lookup/dvla-lookup.module.ajs';
import './email-verification/email-verification.module.ajs';
import './footer/footer.module.ajs';
import './grids/grids.module';
import './gsf/gsf.module.ajs';
import './haynes-pro/haynes-pro.module.ajs';
import './header/header.module.ajs';
import './haynes-pro/haynes-pro.module.ajs';
import './imports/imports.module';
import './inspections/inspections.module.ajs';
import './internationalization/internationalization.module.ajs';
import './invoices/invoices.module.ajs';
import './loan-car-schedule/loan-car-schedule.module.ajs';
import './mechanics/mechanics.module.ajs';
import './messages/messages.module.ajs';
import './mobile/mobile.module.ajs';
import './modals/modals.module.ajs';
import './myob/myob.module.ajs';
import './online-payments/online-payments.module.ajs';
import './partstech/partstech.module.ajs';
import './price-matrix/price-matrix.module';
import './products/products.module.ajs';
import './quickbooks/quickbooks.module.ajs';
import './quotes/quotes.module.ajs';
import './recaptcha/recaptcha.module.ajs';
import './reminders/reminders.module.ajs';
import './reports/reports.module';
import './sessions/sessions.module.ajs';
import './shared/shared.module.ajs';
import './sidebar/sidebar.module.ajs';
import './stock-take/stock-take.module.ajs';
import './stripe/stripe.module.ajs';
import './subscriptions/subscriptions.module.ajs';
import './table/table.module.ajs';
import './templates/templates.module.ajs';
import './tillpayments/tillpayments.module.ajs';
import './tireconnect/tireconnect.module.ajs';
import './transaction-center/transaction-center.module.ajs';
import './uk-postcode/uk-postcode.module.ajs';
import './units/units.module.ajs';
import './userflow/useflow.module.ajs';
import './users/users.module.ajs';
import './vehicles/vehicles.module.ajs';
import './vendor-invoices/vendor-invoices.module';
import './vendor-payments/vendor-payments.module.ajs';
import './vendors/vendors.module.ajs';
import './vv-garage/vv-garage.module.ajs';
import './workshoppay/workshoppay.module.ajs';
import './xero/xero.module.ajs';

angular.module('app-lite', [
  // Core
  'app-lite.core',

  // Components
  'app-lite.admin-dashboard',
  'app-lite.ams-rewards',
  'app-lite.api',
  'app-lite.assembly-payments',
  'app-lite.attachments',
  'app-lite.azure-sso',
  'app-lite.biller',
  'app-lite.branches',
  'app-lite.business-intelligence',
  'app-lite.carfax',
  'app-lite.chargify',
  'app-lite.companies',
  'app-lite.company-lists',
  'app-lite.customer-payments',
  'app-lite.customer-portal',
  'app-lite.customers',
  'app-lite.dealers',
  'app-lite.dvla-lookup',
  'app-lite.email-verification',
  'app-lite.footer',
  'app-lite.grids',
  'app-lite.gsf',
  'app-lite.haynes-pro',
  'app-lite.header',
  'app-lite.imports',
  'app-lite.inspections',
  'app-lite.internationalization',
  'app-lite.invoices',
  'app-lite.loanCar',
  'app-lite.mechanics',
  'app-lite.messages',
  'app-lite.mobile',
  'app-lite.modals',
  'app-lite.myob',
  'app-lite.online-payments',
  'app-lite.partstech',
  'app-lite.price-matrix',
  'app-lite.products',
  'app-lite.quickbooks',
  'app-lite.quotes',
  'app-lite.recaptcha',
  'app-lite.reminders',
  'app-lite.reports',
  'app-lite.sessions',
  'app-lite.shared',
  'app-lite.sidebar',
  'app-lite.stock-take',
  'app-lite.stripe',
  'app-lite.subscriptions',
  'app-lite.table',
  'app-lite.templates',
  'app-lite.tillpayments',
  'app-lite.tireconnect',
  'app-lite.transaction-center',
  'app-lite.uk-postcode',
  'app-lite.units',
  'app-lite.userflow',
  'app-lite.users',
  'app-lite.vehicles',
  'app-lite.vendors',
  'app-lite.vendor-invoices',
  'app-lite.vendor-payments',
  'app-lite.vv-garage',
  'app-lite.workshopPay',
  'app-lite.xero'
]);
